import { useState } from "react";
import { Button, Card, Checkbox, Stack, Text } from "@/components/ui";
import type { Area } from "@/lib/types";
import { useCambiarAreas } from "../hooks/use-usuarios-mutations";

/**
 * Editor de áreas asignadas · genera el set inicial cruzando los
 * nombres del usuario con el catálogo (el backend devuelve nombres,
 * el PUT espera ids).
 */
export function SeccionAreas({
  usuarioId,
  areasActuales,
  todasAreas,
}: {
  usuarioId: string;
  areasActuales: string[];
  todasAreas: Area[];
}) {
  const [sel, setSel] = useState<Set<string>>(
    new Set(todasAreas.filter((a) => areasActuales.includes(a.nombre)).map((a) => a.id))
  );
  const guardar = useCambiarAreas();

  const toggle = (id: string) => {
    const next = new Set(sel);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    setSel(next);
  };

  return (
    <Card padding="md">
      <Stack gap="sm">
        <Text size="xs" fw={600} className="uppercase tracking-wide" c="dimmed">
          Áreas
        </Text>
        {todasAreas.length === 0 ? (
          <Text size="xs" c="dimmed">
            No hay áreas en el catálogo.
          </Text>
        ) : (
          <div className="h-45 overflow-y-auto pr-1">
            <Stack gap={6}>
              {todasAreas.map((a) => (
                <Checkbox key={a.id} label={a.nombre} checked={sel.has(a.id)} onCheckedChange={() => toggle(a.id)} />
              ))}
            </Stack>
          </div>
        )}
        <Button size="xs" fullWidth loading={guardar.isPending} onClick={() => guardar.mutate({ usuarioId, areaIds: Array.from(sel) })}>
          Guardar áreas
        </Button>
      </Stack>
    </Card>
  );
}
